import { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import BarCodeComponentForProduction from "../../lib/BarCodeComponentForProduction";
import BOMOrderHistory from "./BOMOrderHistory";
import BOMModals from "./BOMModals";

// Extracted components
import LockScreenView from "./LockScreen";
import ProductDetailPanel from "./ProductDetailPanel";
import ChooseProductDrawer from "./ChooseProductDrawer";
import MakeToStockModal from "./MakeToStockModal";
import MakeToOrderModal from "./MakeToOrderModal";
import SearchedProductsDrawer from "./SearchedProductsDrawer";
import RemarksDrawer from "./RemarksDrawer";
import OtherChargesDrawer from "./OtherChargesDrawer";
import SideMenuDrawer from "./SideMenuDrawer";
import StockValidationModal from "./StockValidationModal";
import ShortcutsModal from "./ShortcutsModal";
import HeaderBar from "./HeaderBar";
import CartSection from "./CartSection";

// Extracted hooks
import useProductionHandlers from "./useProductionHandlers";
import useProductionEffects from "./useProductionEffects";
import useProductionKeyboard from "./useProductionKeyboard";

// Extracted utilities and storage helpers
import { savingOtherChargesData, savingRemarks, savingTareWeight, savingTotalWeight, savingCopies, savingPricingMethod, savingSearchedProductsData } from "./productionStorage";
import { getBOMCartColumns } from "./columnDefinitions";

// Assets
import CustomerSearch from "../../assets/images/c-serach.svg";

const ProductionOrder = () => {
  const { username } = getOAuthHeaders();
  const history = useHistory();
  const domainURL = process.env.REACT_APP_domain;
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const version_number = process.env.REACT_APP_release_no || "24Q3.4.0";
  const userData = useAuthStore.getState().userData;
  const tillData = useAuthStore((s) => s.tillData);
  const posType = usePOSConfigStore((s) => s.posType);
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const printerURL = tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl;

  const [chooseProduct, setChooseProduct] = useState(false);
  const [tillLink, setTillLink] = useState(false);
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const [productSearchInput, setProductSearchInput] = useState("");
  const [quantityInputValue, setQuantityInputValue] = useState(() => {
    const value = localStorage.getItem("quantityInputValue");
    if (value) return parseInt(value);
    return posConfig?.showTareWeight === "Y" ? 0 : 1;
  });
  const [keyBoardInputValue, setKeyBoardInputValue] = useState(() => {
    const value = localStorage.getItem("quantityInputValue");
    return value ? parseInt(value) : 1;
  });
  const [isFirstInput, setIsFirstInput] = useState(true);
  const [selectedKey, setSelectedKey] = useState(null);
  const [isNewInput, setIsNewInput] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(() => {
    const product = localStorage.getItem("selectedProduct");
    return product ? JSON.parse(product) : null;
  });
  const [selectedProductSalePrice, setSelectedProductSalePrice] = useState(() => {
    const price = localStorage.getItem("selectedProductSalePrice");
    return price ? parseFloat(price) : 0;
  });
  const [chooseProductsData, setChooseProductsData] = useState([]);
  const [formattedDate, setFormattedDate] = useState(() => localStorage.getItem("formattedDate") || "");
  const [searchedProduct, setSearchedProduct] = useState("");
  const [chooseSearchedProduct, setChooseSearchedProduct] = useState("");
  const [searchedProductsData, setSearchedProductsData] = useState(() => {
    const data = localStorage.getItem("searchedProductsData");
    return data ? JSON.parse(data) : [];
  });
  const [searchedProductsFlag, setSearchedProductsFlag] = useState(false);
  const [searchedProductsDrawerData, setSearchedProductsDrawerData] = useState([]);
  const [subtotal, setSubtotal] = useState(() => {
    const price = localStorage.getItem("subtotal");
    return price ? parseFloat(price) : 0;
  });
  const [totalItems, setTotalItems] = useState(() => {
    const count = localStorage.getItem("totalItems");
    return count ? parseInt(count) : 0;
  });
  const [totalQty, setTotalQty] = useState(() => localStorage.getItem("totalQty") || 0);
  const [totalSalePrice, setTotalSalePrice] = useState(() => {
    const price = localStorage.getItem("totalSalePrice");
    return price ? parseFloat(price) : 0;
  });
  const [showRemarks, setShowRemarks] = useState(false);
  const [otherCharges, setOtherCharges] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [remarks, setRemarks] = useState(() => localStorage.getItem("remarks") || "");
  const [showInputFields, setShowInputFields] = useState(false);
  const [QtyShowInputFields, setQtyShowInputFields] = useState(false);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [mtsModalVisible, setMtsModalVisible] = useState(false);
  const [mtoModalVisible, setMtoModalVisible] = useState(false);
  const [searchTextStock, setSearchTextStock] = useState("");
  const [searchTextOrder, setSearchTextOrder] = useState("");
  const [otherChargesData, setOtherChargesData] = useState(() => {
    const data = localStorage.getItem("otherChargesData");
    return data ? JSON.parse(data) : [];
  });
  const [tempOtherChargesData, setTempOtherChargesData] = useState([]);
  const [pricingMethod, setPricingMethod] = useState(() => localStorage.getItem("pricingMethod") || "");
  const [showOrderHistory, setShowOrderHistory] = useState(false);
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const [reverseOrderData, setReverseOrderData] = useState(() => {
    const data = localStorage.getItem("reverseOrderData");
    return data ? JSON.parse(data) : [];
  });
  const [isStockModal, setIsStockModal] = useState(() => !!localStorage.getItem("isStockModal"));
  const [isVisible, setIsVisible] = useState(false);
  const [stockValidationData, setStockValidationData] = useState([]);
  const [disableSearch, setDisableSearch] = useState(() => !!localStorage.getItem("disableSearch"));
  const [tempRemarks, setTempRemarks] = useState("");
  const [selectedTotalQuantity, setSelectedTotalQuantity] = useState(0);
  const [tempQuantityInputValue, setTempQuantityInputValue] = useState(() => {
    const value = localStorage.getItem("quantityInputValue");
    return value ? parseInt(value) : 1;
  });
  const [totalWeights, setTotalWeights] = useState(0);
  const [isWeightPopupVisible, setIsWeightPopupVisible] = useState(false);
  const [tempSelectProduct, setTempSelectProduct] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [isLocked, setIsLocked] = useState(false);

  const hasReverseOrderData = reverseOrderData && reverseOrderData.length > 0;

  const inputRef = useRef(null);
  const totalQtyRef = useRef(null);
  const qtyInputRef = useRef(null);
  const qtyRef = useRef(null);
  const firstInputRef = useRef(null);
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const csBunitId = tillData.tillAccess.csBunit.csBunitId;
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const rightRef = useRef(null);
  const textAreaRef = useRef(null);
  const keyboardRef = useRef(null);
  const buttonRef = useRef(null);
  const inputSearchRef = useRef(null);
  const scrollRef = useRef(null);
  const tableRef = useRef(null);
  const plusButtonRef = useRef(null);
  const pricingMethodRef = useRef(null);
  const qtyUnitInputRef = useRef(null);
  const shortcutsRef = useRef(null);

  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [selectedProductIndex, setSelectedProductIndex] = useState(null);
  const [shortcutsListModalOpen, setShortcutsListModalOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  const [originalValue, setOriginalValue] = useState(null);
  const [editingKey, setEditingKey] = useState(null);
  const [selectedInputType, setSelectedInputType] = useState("");
  const [editingValue, setEditingValue] = useState("");
  const [showAltUnderline, setShowAltUnderline] = useState(false);

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;

  const [expiryDate, setExpiryDate] = useState(() => localStorage.getItem("expiryDate") || "");
  const [totalWeight, setTotalWeight] = useState(() => {
    const weight = localStorage.getItem("totalWeight");
    return weight ? parseFloat(weight) : 0;
  });
  const [tareWeight, setTareWeight] = useState(() => {
    const weight = localStorage.getItem("tareWeight");
    return weight ? parseFloat(weight) : 0;
  });
  const [copies, setCopies] = useState(() => {
    const value = localStorage.getItem("copies");
    return value ? parseInt(value) : 1;
  });
  const [loading, setLoading] = useState(false);
  const [chooseAProductLoading, setChooseAProductLoading] = useState(false);

  // ── Handlers hook ──
  const handlers = useProductionHandlers({
    tillData,
    posConfig,
    csBunitId,
    pricePrecision,
    printerURL,
    domainURL,
    redirectUrl,
    username,
    searchedProductsData,
    setSearchedProductsData,
    quantityInputValue,
    setQuantityInputValue,
    keyBoardInputValue,
    setKeyBoardInputValue,
    tempQuantityInputValue,
    setTempQuantityInputValue,
    selectedProduct,
    setSelectedProduct,
    selectedProductSalePrice,
    setSelectedProductSalePrice,
    chooseProductsData,
    setChooseProductsData,
    chooseSearchedProduct,
    formattedDate,
    setFormattedDate,
    searchedProduct,
    setSearchedProduct,
    setChooseSearchedProduct,
    setSearchedProductsFlag,
    setSearchedProductsDrawerData,
    subtotal,
    setSubtotal,
    totalItems,
    setTotalItems,
    totalQty,
    setTotalQty,
    totalSalePrice,
    setTotalSalePrice,
    otherChargesData,
    setOtherChargesData,
    tempOtherChargesData,
    setTempOtherChargesData,
    pricingMethod,
    setPricingMethod,
    reverseOrderData,
    setReverseOrderData,
    isStockModal,
    setIsStockModal,
    isVisible,
    setIsVisible,
    stockValidationData,
    setStockValidationData,
    disableSearch,
    setDisableSearch,
    selectedRowKey,
    setSelectedRowKey,
    showInputFields,
    setShowInputFields,
    QtyShowInputFields,
    setQtyShowInputFields,
    selectedQuantity,
    setSelectedQuantity,
    selectedTotalQuantity,
    setSelectedTotalQuantity,
    selectedKey,
    setSelectedKey,
    isNewInput,
    setIsNewInput,
    isFirstInput,
    setIsFirstInput,
    editingKey,
    setEditingKey,
    editingValue,
    setEditingValue,
    selectedInputType,
    setSelectedInputType,
    originalValue,
    setOriginalValue,
    totalWeight,
    setTotalWeight,
    tareWeight,
    setTareWeight,
    totalWeights,
    setTotalWeights,
    expiryDate,
    setExpiryDate,
    copies,
    setCopies,
    isWeightPopupVisible,
    setIsWeightPopupVisible,
    tempSelectProduct,
    setTempSelectProduct,
    setChooseProduct,
    chooseProduct,
    setLoading,
    setChooseAProductLoading,
    setMtsModalVisible,
    setMtoModalVisible,
    searchTextStock,
    setSearchTextStock,
    searchTextOrder,
    setSearchTextOrder,
    remarks,
    setRemarks,
    showRemarks,
    setShowRemarks,
    otherCharges,
    setOtherCharges,
    layoutName,
    setLayoutName,
    tempRemarks,
    setTempRemarks,
    tillLink,
    setTillLink,
    isLocked,
    setIsLocked,
    showOrderHistory,
    setShowOrderHistory,
    inputSearchRef,
    plusButtonRef,
    pricingMethodRef,
    qtyUnitInputRef,
    hasReverseOrderData,
  });

  const scrollToRow = (index) => {
    const sc = shortcutsRef.current?.view;
    if (!sc) return;
    const row = document.querySelector(`.shortcutTable .ant-table-row:nth-child(${index + 1})`);
    if (!row) return;
    if (row.offsetTop < sc.scrollTop) sc.scrollTop = row.offsetTop;
    else if (row.offsetTop + row.clientHeight > sc.scrollTop + sc.clientHeight) sc.scrollTop = row.offsetTop - sc.clientHeight + row.clientHeight;
  };

  const calculateColumns = () => {
    const c = document.querySelector(".productionScroll"),
      p = document.querySelector("#product-0");
    return c && p ? Math.floor(c.offsetWidth / p.offsetWidth) : 1;
  };

  const scrollToProduct = (index) => {
    if (scrollRef.current) scrollRef.current.scrollTop(Math.floor(index / 4) * 160);
  };

  useProductionEffects({
    isWeightPopupVisible,
    selectedProduct,
    setDisableSearch,
    disableSearch,
    otherCharges,
    firstInputRef,
    rightRef,
    keyBoardInputValue,
    qtyRef,
    selectedQuantity,
    QtyShowInputFields,
    inputRef,
    showInputFields,
    qtyInputRef,
    totalQtyRef,
    showRemarks,
    textAreaRef,
    buttonRef,
    chooseProduct,
    searchedProductsData,
    shortcutsListModalOpen,
    showOrderHistory,
    setCurrentDateTime,
    setShowAltUnderline,
    reverseOrderData,
    pricePrecision,
    setOtherChargesData,
    setSelectedProduct,
    setTotalSalePrice,
    setFormattedDate,
    setRemarks,
    setQuantityInputValue,
    setTempQuantityInputValue,
    setSearchedProductsData,
    updateProductWithUOMData: handlers.updateProductWithUOMData,
    modifiedData: handlers.modifiedData,
    updateCartTotals: handlers.updateCartTotals,
    selectedProductSalePrice,
    subtotal,
    otherChargesData,
    pricingMethod,
    quantityInputValue,
    setTotalWeights,
    tempOtherChargesData,
    setTempOtherChargesData,
    selectedRowIndex,
    setSelectedRowIndex,
    handleChooseProduct: handlers.handleChooseProduct,
    inputSearchRef,
    hasReverseOrderData,
    totalSalePrice,
    setShowOrderHistory,
    handleOtherChanges: handlers.handleOtherChanges,
    remarks,
    setShowRemarks,
    setTempRemarks,
    handleProceed: handlers.handleProceed,
    handleCancel: handlers.handleCancel,
    setIsLocked,
    setShortcutsListModalOpen,
    shortcutsRef,
    scrollToRow,
    plusButtonRef,
  });

  // ── Global keyboard handler ──
  useProductionKeyboard({
    handlers,
    shortcutsListModalOpen,
    setShortcutsListModalOpen,
    hasReverseOrderData,
    setTempQuantityInputValue,
    isVisible,
    setIsVisible,
    setSelectedRowKey,
    setShowInputFields,
    setSelectedQuantity,
    setSelectedTotalQuantity,
    editingValue,
    setEditingValue,
    originalValue,
    QtyShowInputFields,
    setQtyShowInputFields,
    searchedProductsData,
    selectedRowKey,
    disableSearch,
    chooseProduct,
    chooseProductsData,
    setSelectedProductIndex,
    selectedProductIndex,
    otherCharges,
    setOtherCharges,
    showRemarks,
    setShowRemarks,
    tempRemarks,
    setTempRemarks,
    setRemarks,
    remarks,
    tempOtherChargesData,
    setOtherChargesData,
    selectedProduct,
    tillLink,
    setTillLink,
    isLocked,
    setIsLocked,
    showOrderHistory,
    setShowOrderHistory,
    totalSalePrice,
    plusButtonRef,
    pricingMethodRef,
    qtyUnitInputRef,
    inputSearchRef,
    calculateColumns,
    scrollToProduct,
  });

  // ── Popover handler ──
  const handleButtonClick = () => setPopoverVisible(!isPopoverVisible);

  // ── BOMProps for child components ──
  const BOMProps = {
    showOrderHistory,
    setShowOrderHistory,
    colorVariable,
    CustomerSearch,
    isPopoverVisible,
    setPopoverVisible,
    handleButtonClick,
    searchedProductsData,
    setReverseOrderData,
    checkStockData: handlers.checkStockData,
    setIsVisible,
    isStockModal,
    setIsStockModal,
    selectedProduct,
    setSelectedProduct,
    setSearchedProductsData,
    handleCancel: handlers.handleCancel,
    updateCartTotals: handlers.updateCartTotals,
    chooseProduct,
    setChooseProduct,
    chooseSearchedProduct,
    setChooseSearchedProduct,
    chooseProductsData,
    setChooseProductsData,
    inputRef,
    handleProductSelect: handlers.handleProductSelect,
    searchedProductsFlag,
    setSearchedProductsFlag,
    searchedProductsDrawerData,
    handleAddSearchedProduct: handlers.handleAddSearchedProduct,
    showRemarks,
    setShowRemarks,
    keyboardRef,
    handleShift: handlers.handleShift,
    setLayoutName,
    setOtherCharges,
    setTempOtherChargesData,
    setOtherChargesData,
    otherCharges,
    otherChargesData,
    tempOtherChargesData,
    isVisible,
    stockValidationData,
    handleScroll: handlers.handleScroll,
    remarks,
    setRemarks,
    layoutName,
    isWeightPopupVisible,
    setIsWeightPopupVisible,
    selectedKey,
    searchedProduct,
    tempSelectProduct,
    setTempSelectProduct,
    savingSearchedProductsData,
    setQuantityInputValue,
    showAltUnderline,
    setShowAltUnderline,
    setTareWeight,
    tareWeight,
  };

  // ── BOM cart columns ──
  const bomCartColumns = getBOMCartColumns({
    editingKey,
    selectedInputType,
    editingValue,
    setEditingValue,
    handleEditStart: handlers.handleEditStart,
    handleInputSubmit: handlers.handleInputSubmit,
    qtyUnitInputRef,
    hasReverseOrderData,
    disableSearch,
    handleDeleteSearchedProduct: handlers.handleDeleteSearchedProduct,
    posConfig,
    pricePrecision,
  });

  // ── Render ──
  return (
    <>
      {!showOrderHistory && !isLocked && !isWeightPopupVisible && !showRemarks && !otherCharges && (
        <BarCodeComponentForProduction onScan={handlers.onBarcodeInput} setProductSearchInput={setSearchedProduct} productSearchInput={searchedProduct} />
      )}

      {!showOrderHistory && !isLocked && (
        <div style={{ background: "#fff", height: "100vh" }}>
          <HeaderBar
            setTillLink={setTillLink}
            posConfigData={{ posType }}
            handleCancel={handlers.handleCancel}
            history={history}
            posConfig={posConfig}
            totalSalePrice={totalSalePrice}
            setShowOrderHistory={setShowOrderHistory}
            formattedDateTime={formattedDateTime}
            setIsLocked={setIsLocked}
            userData={userData}
          />

          <div style={{ display: "flex", height: "91vh" }}>
            <CartSection
              inputSearchRef={inputSearchRef}
              productSearchInput={productSearchInput}
              setProductSearchInput={setProductSearchInput}
              searchedProduct={searchedProduct}
              setSearchedProduct={setSearchedProduct}
              hasReverseOrderData={hasReverseOrderData}
              disableSearch={disableSearch}
              posConfig={posConfig}
              selectedRowKey={selectedRowKey}
              setSelectedRowKey={setSelectedRowKey}
              showInputFields={showInputFields}
              setShowInputFields={setShowInputFields}
              setQtyShowInputFields={setQtyShowInputFields}
              setSelectedQuantity={setSelectedQuantity}
              setSelectedTotalQuantity={setSelectedTotalQuantity}
              setSelectedKey={setSelectedKey}
              setIsNewInput={setIsNewInput}
              activeTabKey={activeTabKey}
              qtyInputRef={qtyInputRef}
              totalQtyRef={totalQtyRef}
              bomCartColumns={bomCartColumns}
              searchedProductsData={searchedProductsData}
              totalItems={totalItems}
              totalQty={totalQty}
              subtotal={subtotal}
              currenciesList={currenciesList}
              pricePrecision={pricePrecision}
              totalSalePrice={totalSalePrice}
              totalWeights={totalWeights}
            />

            <ProductDetailPanel
              selectedProduct={selectedProduct}
              posConfig={posConfig}
              hasReverseOrderData={hasReverseOrderData}
              tempQuantityInputValue={tempQuantityInputValue}
              setTempQuantityInputValue={setTempQuantityInputValue}
              updateQuantityAndProducts={handlers.updateQuantityAndProducts}
              setQtyShowInputFields={setQtyShowInputFields}
              setIsFirstInput={setIsFirstInput}
              setShowInputFields={setShowInputFields}
              totalWeight={totalWeight}
              setTotalWeight={setTotalWeight}
              setTareWeight={setTareWeight}
              searchedProductsData={searchedProductsData}
              checkStockData={handlers.checkStockData}
              savingTotalWeightFn={savingTotalWeight}
              handleGetWeight={handlers.handleGetWeight}
              tareWeight={tareWeight}
              savingTareWeightFn={savingTareWeight}
              quantityInputValue={quantityInputValue}
              formattedDate={formattedDate}
              expiryDate={expiryDate}
              copies={copies}
              savingCopiesFn={savingCopies}
              setCopies={setCopies}
              otherChargesData={otherChargesData}
              showAltUnderline={showAltUnderline}
              handleOtherChanges={handlers.handleOtherChanges}
              currenciesList={currenciesList}
              pricePrecision={pricePrecision}
              totalSalePrice={totalSalePrice}
              totalWeights={totalWeights}
              remarks={remarks}
              setShowRemarks={setShowRemarks}
              setTempRemarks={setTempRemarks}
              pricingMethod={pricingMethod}
              setPricingMethod={setPricingMethod}
              savingPricingMethodFn={savingPricingMethod}
              pricingMethodRef={pricingMethodRef}
              plusButtonRef={plusButtonRef}
              showInputFields={showInputFields}
              posConfigEnableQtyUnitKeypad={posConfig?.enableQtyUnitKeypad}
              posConfigEnableTotalQtyKeypad={posConfig?.enableTotalQtyKeypad}
              activeTabKey={activeTabKey}
              setActiveTabKey={setActiveTabKey}
              setIsNewInput={setIsNewInput}
              qtyInputRef={qtyInputRef}
              totalQtyRef={totalQtyRef}
              selectedQuantity={selectedQuantity}
              setSelectedQuantity={setSelectedQuantity}
              selectedKey={selectedKey}
              selectedRowKey={selectedRowKey}
              handleAmount={handlers.handleAmount}
              handleEnter={handlers.handleEnter}
              decrementQuantity={handlers.decrementQuantity}
              incrementQuantity={handlers.incrementQuantity}
              handleTotalAmount={handlers.handleTotalAmount}
              handleTotalEnter={handlers.handleTotalEnter}
              decrementTotalQuantity={handlers.decrementTotalQuantity}
              incrementTotalQuantity={handlers.incrementTotalQuantity}
              selectedTotalQuantity={selectedTotalQuantity}
              setSelectedTotalQuantity={setSelectedTotalQuantity}
              setSelectedRowKey={setSelectedRowKey}
              QtyShowInputFields={QtyShowInputFields}
              setQtyShowInputFields={setQtyShowInputFields}
              setKeyBoardInputValue={setKeyBoardInputValue}
              keyBoardInputValue={keyBoardInputValue}
              inputRef={inputRef}
              handleAmountQty={handlers.handleAmountQty}
              handleEnterQty={handlers.handleEnterQty}
              decrementQuantity1={handlers.decrementQuantity1}
              incrementQuantity1={handlers.incrementQuantity1}
              handleCancel={handlers.handleCancel}
              handleProceed={handlers.handleProceed}
              handleChooseProduct={handlers.handleChooseProduct}
              chooseAProductLoading={chooseAProductLoading}
              buttonRef={buttonRef}
            />
          </div>
        </div>
      )}

      <LockScreenView isLocked={isLocked} colorVariable={colorVariable} userData={userData} handleLogin={handlers.handleLogin} />

      <BOMOrderHistory {...BOMProps} />
      <BOMModals {...BOMProps} />

      <ChooseProductDrawer
        chooseProduct={chooseProduct}
        setChooseProduct={setChooseProduct}
        chooseSearchedProduct={chooseSearchedProduct}
        setChooseSearchedProduct={setChooseSearchedProduct}
        chooseProductsData={chooseProductsData}
        selectedProductIndex={selectedProductIndex}
        handleProductSelect={handlers.handleProductSelect}
        handleScroll={handlers.handleScroll}
        scrollRef={scrollRef}
        inputRef={inputRef}
      />

      <MakeToStockModal
        mtsModalVisible={mtsModalVisible}
        setMtsModalVisible={setMtsModalVisible}
        setChooseProductsData={setChooseProductsData}
        searchTextStock={searchTextStock}
        setSearchTextStock={setSearchTextStock}
        setLoading={setLoading}
        loading={loading}
        handleSearchedStock={handlers.handleSearchedStock}
        handleStockScroll={handlers.handleStockScroll}
        tableRef={tableRef}
        chooseProductsData={chooseProductsData}
        updateChooseProductsData={handlers.updateChooseProductsData}
        handleChooseProductSelect={handlers.handleChooseProductSelect}
      />
      <MakeToOrderModal
        mtoModalVisible={mtoModalVisible}
        setMtoModalVisible={setMtoModalVisible}
        setChooseProductsData={setChooseProductsData}
        searchTextOrder={searchTextOrder}
        setSearchTextOrder={setSearchTextOrder}
        setLoading={setLoading}
        loading={loading}
        handleSearchedOrder={handlers.handleSearchedOrder}
        handleOrderScroll={handlers.handleOrderScroll}
        tableRef={tableRef}
        chooseProductsData={chooseProductsData}
        updateChooseProductsData={handlers.updateChooseProductsData}
        handleChooseProductSelect={handlers.handleChooseProductSelect}
      />

      <SearchedProductsDrawer
        searchedProductsFlag={searchedProductsFlag}
        setSearchedProductsFlag={setSearchedProductsFlag}
        searchedProductsDrawerData={searchedProductsDrawerData}
        currenciesList={currenciesList}
        handleAddSearchedProduct={handlers.handleAddSearchedProduct}
      />

      <RemarksDrawer
        showRemarks={showRemarks}
        setShowRemarks={setShowRemarks}
        remarks={remarks}
        tempRemarks={tempRemarks}
        setTempRemarks={setTempRemarks}
        setRemarks={setRemarks}
        savingRemarksFn={savingRemarks}
        textAreaRef={textAreaRef}
        keyboardRef={keyboardRef}
        layoutName={layoutName}
        setLayoutName={setLayoutName}
        handleShift={handlers.handleShift}
      />

      <OtherChargesDrawer
        otherCharges={otherCharges}
        setOtherCharges={setOtherCharges}
        tempOtherChargesData={tempOtherChargesData}
        setTempOtherChargesData={setTempOtherChargesData}
        otherChargesData={otherChargesData}
        setOtherChargesData={setOtherChargesData}
        savingOtherChargesDataFn={savingOtherChargesData}
        firstInputRef={firstInputRef}
      />

      <SideMenuDrawer
        tillLink={tillLink}
        setTillLink={setTillLink}
        tillData={tillData}
        domainURL={domainURL}
        handleCancel={handlers.handleCancel}
        confirmUnlink={handlers.confirmUnlink}
        version_number={version_number}
      />

      <StockValidationModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        setSelectedRowKey={setSelectedRowKey}
        setShowInputFields={setShowInputFields}
        setSelectedQuantity={setSelectedQuantity}
        setSelectedTotalQuantity={setSelectedTotalQuantity}
        stockValidationData={stockValidationData}
        activeTabKey={activeTabKey}
      />

      <ShortcutsModal
        shortcutsListModalOpen={shortcutsListModalOpen}
        setShortcutsListModalOpen={setShortcutsListModalOpen}
        shortcutsRef={shortcutsRef}
        selectedRowIndex={selectedRowIndex}
      />
    </>
  );
};

export default ProductionOrder;
